// 中文版
export default {

  home: '首页',
  aboutUs: '关于我们',
  productsAndServices: '产品与服务',
  projectCases: '项目案例',
  contactUs: '📩 联系我们',
  contactUs2: '联系我们',
  scrollDown: '鼠标滚动',
  companyName: 'Ocean Harmony Trade Co., Ltd',
  companyIntro: '公司简介',
  brandStory:'品牌故事',
  developmentHistory: '发展历程',
  corporateCulture: '企业文化',
  qualificationsAndHonors: '资质荣誉',
  partners: '合作伙伴',
  customer: '客户',
  domesticNetwork: '国内网络',
  overseasNetwork: '海外网络',
  businessOutlets: '经营网点',
  fullCategoryTransportService: '全品类运输服务',
  oneStopSupplyChainService: '“一站式”供应链服务',
  mainEngineeringMaterialsProducts: '主营工程物资产品',
  logisticsBusiness: '物流业务',
  materialsBusiness: '物资业务',
  fullSupplyChainBusiness:'全程供应链业务',
  aboutOceanHarmony: '了解 Ocean Harmony',
  historyAndEvolution: '历史沿革 (2024 ~ 至今)',
  companyHonors: '公司荣誉',
  address: '地址',
  phone: '电话',
  email: '邮箱',
  send: '发送',
  weChatQRCode: '微信公众号二维码',
  scanToFollowUs: '扫一扫关注我们',
  contact: '随时发送您的咨询！',
  mondayToFriday: '周日-周四',
  leaveMessage: '留言内容',
  subject: '公司名称',
  nickname: '您的称呼',
  cooperationIntent: '合作意向',
  companyTopName: "中成集团",
  transportation: "中成运输",
  copyright: "版权所有",
  companyTopTitle: "中成国际运输深圳有限公司",
  projectDetail:'项目详情',

  enterYourName: '如：王经理/张先生',
  nameRequired: '请输入您的称呼',
  enterYourEmail: '选填，方便接收报价方案资料',
  enterYourPhone: '请输入您的手机号或微信手机号，方便专员快速联系您',
  phoneRequired: '请输入手机号',
  invalidPhone: '请输入正确的手机号',
  enterSubject: '请输入公司全称或简称（个人业务请填“个人”）',
  companyRequired: '请输入公司名称',
  selectIntent: '请选择您需要的服务',
  intentLogistics: '我有货物需要运输/报关/仓储（找物流服务）',
  intentTrade: '我想采购商品/需要进出口代理（找外贸与供应链服务）',
  intentSupplier: '我是厂家或服务商，希望提供货源/运力（供应商合作）',
  intentOther: '其他商务咨询（暂不确定具体业务）',
  leaveHintDefault: '请先选择合作意向',
  leaveHintLogistics: '请简述您的货物名称、起运地与目的地（如：广州到香港）、预计重量或体积等。',
  leaveHintTrade: '请简述您需要采购的产品，或需要代办进出口、退税、垫资的货物情况与目标地区。',
  leaveHintSupplier: '请简述贵司主营产品或优势物流航线、合作设想等，我们将转交相关部门评估。',
  leaveHintOther: '请简述您的业务背景与合作诉求，客服专员将为您安排对接相关部门。',
  enterMessageContent: '请填写留言内容',
  enterValidEmail: '请输入有效的邮箱地址',
  messageContentAtLeast10: '留言内容至少 10 个字符',
  nameLengthBetween2And30: '称呼长度在 2 到 30 个字符',
  formSubmitSuccess: '发送成功，感谢您的来信！',
  completeFormBeforeSubmitting: '请完善表单信息后提交',
  submitFailed: '提交失败，请稍后重试',
  slideVerifyLabel: '安全验证',
  verifyDialogTitle: '安全验证',
  verifyDialogDesc: '为保障留言真实有效，请将下方滑块拖动至最右侧后再发送。',
  cancel: '取消',
  slideVerifyText: '按住滑块，拖动到最右侧',
  verificationSuccess: '验证通过',
  completeSlideVerifyFirst: '请先完成滑动验证',
  subjectLengthLimit: '公司名称长度应为 2 到 100 个字符',
  messageContentLengthLimit: '留言长度应为 10 到 500 个字符',
  mainTilte: '深耕工程项目领域，围绕工程项目特性供应以下主营物资产品',
  ViewDetails: '查看详细',
  Loading: '加载中...',
  companyCoverage: "国内<span class=\"map-top\">&nbsp;13&nbsp;</span>家公司覆盖全国沿线主要港口城市",
  businessOutletsTitle1:"Ocean Harmony，当前已在海外设立<span class='w-map-top'>&nbsp;9&nbsp;</span>个直管驻点",
  businessOutletsTitle2:"深耕非洲和东南亚地区超过<span class='w-map-top'>&nbsp;14&nbsp;</span>年",
  qayimatAlmuntajat:"产品清单",
  LanguageMessage:"设置语言成功!",
  WHATSAPP:'WHATSAPP'
};